import { Link } from "react-router-dom";
import carousel1 from './img/carousel-1.jpg';
import carousel2 from './img/carousel-2.jpg';
import about from './img/about.jpg';
import profile from './img/mobile.png';
import feature from './img/feature.jpg';
import icon07 from './img/icon/icon-07-primary.png';
import icon06 from './img/icon/icon-06-primary.png';
import icon03 from './img/icon/icon-03-primary.png';
import icon04 from './img/icon/icon-04-primary.png';
import icon10light from './img/icon/icon-10-light.png';
import icon01light from './img/icon/icon-01-light.png';
import icon06light from './img/icon/icon-06-light.png';
import icon05light from './img/icon/icon-05-light.png';
import icon08light from './img/icon/icon-08-light.png';
import icon07light from './img/icon/icon-07-light.png';
import Teamwork from './img/icon/Teamwork.png';
import Integrity from './img/icon/Integrity.png';
import Innovation from './img/icon/Innovation.png';
import CustomerFocus from './img/icon/CustomerFocus.png';
import team1 from './img/team-1.jpg';
import team2 from './img/team-2.jpg';
import team3 from './img/team-3.jpg';
import team4 from './img/team-4.jpg';
import AdityaBirla from './img/partners/AdityaBirla.jpg';
import Bajaj1 from './img/partners/Bajaj-allianz-general-insurance.webp';
import Bajaj2 from './img/partners/bajaj-allianz-life-insurance-online.jpeg';
import BandhanLife from './img/partners/BandhanLife.jpg';
import Cholamandalam from './img/partners/Cholamandalam.jpg';
import Carehealthinsurance from './img/partners/Carehealthinsurance.png';
import FutureGenerali from './img/partners/FutureGenerali.png';
import GoDigit from './img/partners/Go-Digit.png';
import hdfclife from './img/partners/hdfc-life.jpg';
import ICICI_Lombard from './img/partners/ICICI_Lombard.jpg';
import ICICI_Prudential from './img/partners/ICICI_Prudential.jpg';
import IffcoTokio from './img/partners/IffcoTokio.png';
import KotakGeneral from './img/partners/KotakGeneral.jpg';
import Libertygeneral from './img/partners/Libertygeneral.jpg';
import LIC from './img/partners/LIC.jpg';
import Magma from './img/partners/Magma.png';
import Manipal from './img/partners/Manipal.png';
import MAxLife from './img/partners/MAxLife.jpg';
import NationalInsuarnce from './img/partners/NationalInsuarnce.jpg';
import NivaBupa from './img/partners/NivaBupa.jpg';
import Oriental from './img/partners/Oriental.png';
import raheja from './img/partners/raheja.png';
import Reliance from './img/partners/Reliance.jpg';
import Royal from './img/partners/Royal.jpg';
import SBIG from './img/partners/SBIG.png';
import Shriram from './img/partners/Shriram.png';
import Star from './img/partners/Star.png';
import TATAAIA from './img/partners/TATAAIA.jpg';
import TataAIG from './img/partners/TataAIG.png';
import NewIndia from './img/partners/NewIndia.jpg';
import UnitedIndia from './img/partners/UnitedIndia.jpg';
import UniversalSompo from './img/partners/UniversalSompo.png';
import Zuno from './img/partners/Zuno.jpg';

function Home() {
  window.scrollTo(0,0);
    return (
        <>
             {/* <!-- Carousel Start --> */}
    <div className="container-fluid p-0 mb-5 wow fadeIn" data-wow-delay="0.1s">
      <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="w-100" src={carousel1} alt="Image" />
            <div className="carousel-caption">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <h1 className="display-3 text-dark mb-4 animated slideInDown">
                      Insurance Creates Wealth For Everyone
                    </h1>
                    <p className="fs-5 text-body mb-5">
                    Your Trusted Partner for All Your Insurance Needs Insure Karo Secure Raho……
                    </p>
                    <Link to="/about" className="btn btn-primary py-3 px-5"
                      >More Details</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img className="w-100" src={carousel2} alt="Image" />
            <div className="carousel-caption">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-6">
                    <h1 className="display-3 text-dark mb-4 animated slideInDown">
                      The Best Insurance Begins Here
                    </h1>
                    <p className="fs-5 text-body mb-5">
                    Your Trusted Partner for All Your Insurance Needs Insure Karo Secure Raho……
                    </p>
                    <Link to="/about" className="btn btn-primary py-3 px-5"
                      >More Details</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
    {/* <!-- Carousel End --> */}

    {/* <!-- About Start --> */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <div
              className="position-relative overflow-hidden rounded ps-5 pt-5 h-100"
              style={{minHeight: "400px"}}
            >
              <img
                className="w-100 h-100"
                src={about}
                alt=""
                style={{objectFit: "cover"}}
              />
              <div
                className="position-absolute top-0 start-0 bg-white rounded pe-3 pb-3"
                style={{width: "200px", height: "200px"}}
              >
                <div
                  className="d-flex flex-column justify-content-center text-center bg-primary rounded h-100 p-3"
                >
                  <h1 className="text-white mb-0">25</h1>
                  <h2 className="text-white">Years</h2>
                  <h5 className="text-white mb-0">Experience</h5>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="h-100">
              <h1 className="display-6 mb-5">
                We're Here To Assist You With Exploring Protection
              </h1>
              <p className="fs-5 text-primary mb-4">
              Our commitment to expertise, comprehensive coverage, and personalized service sets us apart as a trusted partner for our clients
              </p>
              <div className="row g-4 mb-4">
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <img
                      className="flex-shrink-0 me-3"
                      src={icon04}
                      alt=""
                    />
                    <h5 className="mb-0">Flexible Insurance Plans</h5>
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="d-flex align-items-center">
                    <img
                      className="flex-shrink-0 me-3"
                      src={icon03}
                      alt=""
                    />
                    <h5 className="mb-0">Money Back Guarantee</h5>
                  </div>
                </div>
              </div>
              <p className="mb-4">
              Our mission is to be the most trusted and respected insurance broking company in the industry, known for our exceptional service, expertise, and commitment to our clients.
              </p>
              <div className="border-top mt-4 pt-4">
                <div className="d-flex align-items-center">
                  <img
                    className="flex-shrink-0 rounded-circle me-3"
                    src={profile}
                    alt=""
                  />
                  <h5 className="mb-0">Call Us: +91 8451807462</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- About End --> */}

    {/* <!-- Facts Start --> */}
    <div className="container-fluid overflow-hidden my-5 px-lg-0">
      <div className="container facts px-lg-0">
        <div className="row g-0 mx-lg-0">
          <div className="col-lg-6 facts-text wow fadeIn" data-wow-delay="0.1s">
            <div className="h-100 px-4 ps-lg-0">
              <h1 className="text-white mb-4">Our Vision</h1>
              <p className="text-light mb-5">
              The "Insure Karo, Secure Raho" vision likely focuses on making insurance accessible and secure through a simplified, transparent, and customer-focused approach. For insurance broking specifically, this vision would suggest that the broker's role is to act as an intermediary, helping clients find the most appropriate insurance policies based on their needs while ensuring that the process is straightforward, trustworthy, and protective for the client
              </p>
              <Link to="/home" className="align-self-start btn btn-secondary py-3 px-5"
                >More Details</Link
              >
            </div>
          </div>
          <div className="col-lg-6 facts-counter wow fadeIn" data-wow-delay="0.1s">
            <div className="h-100 px-4 ps-lg-0">
              <h1 className=" mb-4">Our Values</h1>
              <div className="row g-3">
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded h-100 py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={Integrity}
                      alt=""
                    />
                    <h5 className="mb-0">Integrity</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={CustomerFocus}
                      alt=""
                    />
                    <h5 className="mb-0">Customer Focus</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={Innovation}
                      alt=""
                    />
                    <h5 className="mb-0">Innovation</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded h-100 py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={Teamwork}
                      alt=""
                    />
                    <h5 className="mb-0">Teamwork</h5>
                  </div>
                </div>
              </div>
            </div>
              {/* <Link to="/home" className="align-self-start btn btn-secondary py-3 px-5"
                >More Details</Link
              > */}
            </div>
          </div>
          {/* <div className="col-lg-6 facts-counter wow fadeIn" data-wow-delay="0.5s">
            <div className="h-100 px-4 pe-lg-0">
            <h1 className="text-white mb-4">Our Values</h1>
            Integrity: We operate with transparency, honesty, and ethics in all our interactions.
            Customer Focus: We prioritize our clients' needs and goals, providing personalized service and expert advice.
         Innovation: We stay ahead of the curve, leveraging technology and industry trends to deliver cutting-edge solutions.
Teamwork: We collaborate and support each other, fostering a culture of trust, respect, and open communication.
            </div>
          </div> */}
        </div>
      </div>
    </div>
    {/* <!-- Facts End --> */}

    {/* <!-- Features Start --> */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
            <h1 className="display-6 mb-5">Few Reasons Why People Choosing Us!</h1>
            <p className="mb-4">
            Our experienced professionals provide personalized guidance and recommendations.
            We offer a comprehensive range of insurance products from leading insurers.
            We negotiate with insurers to secure the best rates for our clients.
            We prioritize our clients' needs, providing prompt and efficient support.
            </p>
            <div className="row g-3">
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.1s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded h-100 py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={icon06}
                      alt=""
                    />
                    <h5 className="mb-0">Expert Advice</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.2s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={icon03}
                      alt=""
                    />
                    <h5 className="mb-0">Wide Range of Options</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.3s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={icon04}
                      alt=""
                    />
                    <h5 className="mb-0">Exceptional Service</h5>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                <div className="bg-light rounded h-100 p-3">
                  <div
                    className="bg-white d-flex flex-column justify-content-center text-center rounded h-100 py-4 px-3"
                  >
                    <img
                      className="align-self-center mb-3"
                      src={icon07}
                      alt=""
                    />
                    <h5 className="mb-0">Competitive Pricing</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
            <div
              className="position-relative rounded overflow-hidden h-100"
              style={{minHeight: "400px"}}
            >
              <img
                className=" w-100 h-100"
                src={feature}
                alt=""
                style={{objectFit: "cover"}}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- Features End --> */}

    {/* <!-- Service Start --> */}
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto" style={{maxWidth: "500px"}}>
          <h1 className="display-6 mb-5">
            We provide professional Insurance Services
          </h1>
        </div>
        <div className="row g-4 justify-content-center">
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon10light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Life Insurance</h4>
              </div>
              <p className="mb-4">
              Our life insurance plans provide financial protection to our clients' 
              loved ones in the event of their passing.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon01light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Health Insurance</h4>
              </div>
              <p className="mb-4">
              We provide individual and family 
              health insurance plans that offer comprehensive coverage for medical expenses.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon05light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Home Insurance</h4>
              </div>
              <p className="mb-4">
              Ensure your home is safe from unforeseen risks with our simple home insurance policy.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon08light}
                    alt=""
                  /> 
                </div>
                <h4 className="mb-0">General Insurance</h4>
              </div>
              <p className="mb-4">
              We offer a range of general insurance products, 
              including motor insurance, home insurance, and travel insurance.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon07light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Corporate Insurance</h4>
              </div>
              <p className="mb-4">
              Our corporate insurance plans provide comprehensive coverage for businesses, including liability insurance, property insurance, and employee benefits.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="service-item rounded h-100 p-5">
              <div className="d-flex align-items-center ms-n5 mb-4">
                <div
                  className="service-icon flex-shrink-0 bg-primary rounded-end me-4"
                >
                  <img
                    className="img-fluid"
                    src={icon06light}
                    alt=""
                  />
                </div>
                <h4 className="mb-0">Risk Management</h4>
              </div>
              <p className="mb-4">
              We help our clients identify and mitigate risks, providing tailored risk management solutions that meet their unique needs.
              </p>
              {/* <a className="btn btn-light px-3" href="">Read More</a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- Service End --> */}

    {/* <!-- Appointment Start --> */}
    <div
      className="container-fluid appointment my-5 py-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.3s">
            <h1 className="display-6 text-white mb-5">
            POSP Network
            </h1>
            <p className="text-white mb-5">
            At Ebix Insurance Broking, we have an extensive network of Point of Sales Persons (POSPs) who are trained and certified to provide insurance services to our clients. Our POSP network is spread across the country, ensuring that our clients have access to personalized service and expert advice wherever they are.
            </p>
            
          </div>
          <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
          <h1 className="display-6 text-white mb-5">
          POSP Portal
            </h1>
            <p className="text-white mb-5">
            We also have a dedicated POSP portal where our POSPs can sell insurance products to their customers. This portal provides a convenient and secure platform for our POSPs to manage their business and provide excellent service to their clients.
            </p>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- Appointment End --> */}

    {/* <!-- Team Start --> */}
    {/* <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto" style={{maxWidth: "500px"}}>
          <h1 className="display-6 mb-5">Meet Our Professional Team Members</h1>
        </div>
        <div className="row g-4">
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team1} alt="" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team2} alt="" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team3} alt="" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.7s">
            <div className="team-item rounded">
              <img className="img-fluid" src={team4} alt="" />
              <div className="text-center p-4">
                <h5>Full Name</h5>
                <span>Designation</span>
              </div>
              <div className="team-text text-center bg-white p-4">
                <h5>Full Name</h5>
                <p>Designation</p>
                <div className="d-flex justify-content-center">
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-twitter"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-facebook-f"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-youtube"></i
                  ></a>
                  <a className="btn btn-square btn-light m-1" href=""
                    ><i className="fab fa-linkedin-in"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> */}
    {/* <!-- Team End --> */}
    <div className="text-center mx-auto" style={{maxWidth: "500px"}}>
          <h1 className="display-6 mb-5">Our Partners</h1>
        </div>
  <div className="marquee-container overflow-hidden bg-light shadow-sm">
  <div className="marquee-content d-flex align-items-center">
    <div className="marquee-item mx-2" ><img  src={AdityaBirla} alt="Image"  /></div>
    <div className="marquee-item mx-2" ><img  src={Bajaj1} alt="Image"   /></div>
    <div className="marquee-item mx-2" ><img  src={Bajaj2} alt="Image"  /></div>
    <div className="marquee-item mx-2" ><img  src={BandhanLife} alt="Image"  /></div>
    <div className="marquee-item mx-2" ><img  src={Carehealthinsurance} alt="Image"  /></div>
    <div className="marquee-item mx-2" ><img  src={Cholamandalam} alt="Image"   /></div>
    <div className="marquee-item mx-2" ><img  src={FutureGenerali} alt="Image"  /></div>
    <div  className="marquee-item mx-2" ><img  src={GoDigit} alt="Image"   /></div>
    <div  className="marquee-item mx-2" ><img  src={hdfclife} alt="Image" /></div>
    <div  className="marquee-item mx-2" ><img  src={ICICI_Lombard} alt="Image" /></div>
    <div  className="marquee-item mx-2" ><img  src={ICICI_Prudential} alt="Image"  /></div>
    </div>
</div>
  <div  className="marquee-container overflow-hidden bg-light shadow-sm">
  <div  className="marquee-content d-flex align-items-center">
    <div  className="marquee-item mx-2" ><img  src={IffcoTokio} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={KotakGeneral} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={Libertygeneral} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={LIC} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={Magma} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={Manipal} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={NationalInsuarnce} alt="Image"     /></div>
    <div  className="marquee-item mx-2" ><img  src={MAxLife} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={NivaBupa} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={Oriental} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={raheja} alt="Image"    /></div>
  </div>
  
</div>

  <div  className="marquee-container overflow-hidden bg-light shadow-sm">
  <div  className="marquee-content d-flex align-items-center">
    <div  className="marquee-item mx-2" ><img  src={Reliance} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={Royal} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={SBIG} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={Shriram} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={Star} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={TataAIG} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={NewIndia} alt="Image"     /></div>
    <div  className="marquee-item mx-2" ><img  src={UnitedIndia} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={UniversalSompo} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={Zuno} alt="Image"    /></div>
    <div  className="marquee-item mx-2" ><img  src={TATAAIA} alt="Image"    /></div>
  </div>
  
</div>
        </>
    )
}
export default Home;